import type { ReactNode } from "react";
import { Plus } from "lucide-react";

// EmptyState — single source of truth for the "no records yet" card chrome +
// copy across the list/table/kanban renderers (previously duplicated in three
// places). The caller owns the action row, usually import existing records or
// create a single manual record.
export function EmptyState({
  title,
  message,
  noun,
  children,
}: {
  title: string;
  message?: string;
  // Singular record noun ("client", "work order") — drives the guidance copy.
  noun?: string;
  // Optional action (e.g. a manual "Add {noun}" button) rendered under the copy.
  children?: ReactNode;
}) {
  const n = (noun || "record").toLowerCase();
  const copy =
    message ||
    `Ask your Operator to add your first ${n} — say something like “add a ${n} for <something>” — or add one manually below.`;
  return (
    <div className="col-span-full rounded-2xl border border-dashed border-slate-200 bg-white p-10 flex flex-col items-center justify-center text-center">
      <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3 text-slate-400">
        <Plus className="w-5 h-5" />
      </div>
      <p className="text-sm font-medium text-slate-900">{title}</p>
      <p className="text-xs text-slate-500 mt-2 max-w-sm">{copy}</p>
      {children}
    </div>
  );
}
